import { useState, useContext } from "react";

import WordContext from "./WordContext";
import useTicketGenerator from './useTicketGenerator';
import Header from './Header';
import Ticket from './Ticket';
import "./Main.css";

const Main = () => {
	const { verbs, nouns, adjectives, reasons } = useContext(WordContext);
	const isDisabled = 	!verbs || !verbs.length ||
											!nouns || !nouns.length ||
											!adjectives || !adjectives.length ||
											!reasons || !reasons.length;
	const generateTicket = useTicketGenerator({
    verbs,
    nouns,
    adjectives,
    reasons
  });
  const [ticketName, setTicketName] = useState(generateTicket());

	return (
		<div className="main">
			<Header
				onGenerate={() => setTicketName(generateTicket())}
				disableGeneration={isDisabled}
			/>
			<div className="main-ticket-container">
				<Ticket title={ticketName} />
			</div>
		</div>
	);
};

export default Main;
